import * as React from 'react';
import { Layout } from '../Layout';

import {
  useEstimationTargetProps,
  useAddressProps,
  useRoomNumberInputProps,
  useRoomsCountSelectorProps,
  useAreaInputProps,
  useHouseAreaInputProps,
  useLandAreaInputProps,
} from '../../hooks';
import { AddNewCardContainer } from '../AddNewCard';

export const MyHomeContainer: React.FC = () => {
  const estimationTargetProps = useEstimationTargetProps();
  const addressProps = useAddressProps();
  const roomNumberProps = useRoomNumberInputProps();
  const roomsCountSelectorProps = useRoomsCountSelectorProps();
  const areaProps = useAreaInputProps();
  const houseAreaProps = useHouseAreaInputProps();
  const landAreaProps = useLandAreaInputProps();

  return (
    <>
      <Layout
        estimationTargetProps={estimationTargetProps}
        addressProps={addressProps}
        roomsCountSelectorProps={roomsCountSelectorProps}
        areaProps={areaProps}
        roomNumberProps={roomNumberProps}
        houseAreaProps={houseAreaProps}
        landAreaProps={landAreaProps}
      />

      <AddNewCardContainer />
    </>
  );
};
